module.exports = __webpack_public_path__ + "img/cTrader-icon3.fe3b892.png";